import React, { Component } from 'react';
import TeamEstimateLoading from './TeamEstimateLoading.js';
import TeamEstimateDecider from './TeamEstimateDecider.js';
import './TeamEstimate.css';

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      estimate: this.props.estimate || '',
      status: this.props.status || 'disabled',
      type: this.props.type || 'default'
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.onToggleEditing = this.onToggleEditing.bind(this);
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextProps.status !== this.state.status)
      this.setState({ status: this.props.status })

    if (nextProps.type !== this.state.type)
      this.setState({ type: this.props.type })

    if (!this.state.editing && (nextProps.estimate !== this.state.estimate))
      this.setState({ estimate: this.props.estimate })

    if (nextState.estimate !== nextProps.estimate && nextState.estimate !== this.state.estimate)
      this.props.onRoomUpdateStepEstimate({ estimate: nextState.estimate })
  }

  componentDidUpdate(nextProps, nextState) {
    if (this.state.editing && nextState.editing !== this.state.editing)
      this.estimateInput.select();
  }

  handleChange(event) {
    let estimateInputValue = event.target.value.trim()
    let isDigit = /^\d+$/.test(estimateInputValue);
    if (isDigit || estimateInputValue === '')
      this.setState({ estimate: estimateInputValue });
  }

  handleKeyPress(event) {
    if (event.key === 'Enter')
      this.onToggleEditing()
  }

  onToggleEditing() {
    this.setState({ editing: !this.state.editing });
  }

  teamEstimateContents() {
    if (this.state.status === 'disabled') {
      return (<div className='contents'>-</div>);
    } else if (this.state.status === 'in-progress') {
      return (<div className='contents'><TeamEstimateLoading /></div>);
    } else if (this.state.status === 'deciding' && !this.state.editing) {
      return (
        <div className='contents'>
          {this.state.estimate}
          <TeamEstimateDecider
            editing={this.state.editing}
            roomStepsReady={this.props.roomStepsReady}
            onToggleEditing={this.onToggleEditing}
            onRoomNextStep={this.props.onRoomNextStep}
            onRoomEstimatesReset={this.props.onRoomEstimatesReset} />
        </div>
      );
    } else if (this.state.status === 'deciding' && this.state.editing) {
      return (
        <div className='contents'>
          <input type="text"
            maxLength='3'
            onKeyPress={this.handleKeyPress}
            onChange={this.handleChange}
            value={this.state.estimate}
            ref={(input) => { this.estimateInput = input; }} />
          <TeamEstimateDecider
            editing={this.state.editing}
            onToggleEditing={this.onToggleEditing} />
        </div>
      );
    } else if (this.state.status === 'showing') {
      return (<div className='contents'>{this.state.estimate}</div>);
    } else {
      return (<div className='contents'>-</div>);
    }
  }

  render() {
    let editingClass = (this.state.editing) ? 'editing' : '';
    return (
      <div className={`team-estimate ${this.state.status} ${this.state.type} ${editingClass}`}>
        {this.teamEstimateContents()}
      </div>
    );
  }
}

// Status
//   Disabled [default]
//   In Progress
//   Showing
// Type [optimistic, realistic, pessimistic]



// WEBPACK FOOTER //
// ./src/Room/TeamEstimate.js